import { defineSseEvent } from '@terra/shared-sse-contracts';
import { TargetTypeSchema } from '@terra/shared-schemas-orchestrator';
import { z } from 'zod';
import { TargetOnboardingTimelineSchema } from './onboarding-timeline.schema';

export const TARGET_ONBOARDING_TIMELINE_UPDATED_SSE_TYPE =
  'TARGET_ONBOARDING_TIMELINE_UPDATED' as const;

export const TargetOnboardingTimelineUpdatedSsePayloadSchema = z.object({
  targetType: TargetTypeSchema,
  targetId: z.string(),
  timeline: TargetOnboardingTimelineSchema,
});

export const TARGET_ONBOARDING_TIMELINE_UPDATED_SSE_EVENT = defineSseEvent({
  type: TARGET_ONBOARDING_TIMELINE_UPDATED_SSE_TYPE,
  payload: TargetOnboardingTimelineUpdatedSsePayloadSchema,
  channelPrefix: 'target-onboarding-timeline',
  channelKey: ({ targetId }) => targetId,
  target: {
    type: (payload) => payload.targetType,
    id: (payload) => payload.targetId,
  },
});

export type TargetOnboardingTimelineUpdatedSsePayload = z.infer<
  typeof TargetOnboardingTimelineUpdatedSsePayloadSchema
>;
